import React, { ReactNode } from 'react';

import { Author } from '../../components/Author';
import { ImageProps } from '../../components/Image/types';

export interface BlogQuoteProps {
  quote?: ReactNode;
  authorImage?: ImageProps;
  authorName?: string;
  authorPosition?: string;
}

export const BlogQuote = ({
  quote,
  authorImage,
  authorName,
  authorPosition,
}: BlogQuoteProps) => {
  return (
    <figure className="BlogQuote">
      {quote && (
        <blockquote className="pl-24 border-l-2 border-blue-101">
          {quote}
        </blockquote>
      )}
      <figcaption className="mt-36">
        <Author>
          {authorImage && <Author.Image {...authorImage} />}
          <Author.Infos>
            <Author.Name>{authorName}</Author.Name>
            {authorPosition && (
              <Author.Position>{authorPosition}</Author.Position>
            )}
          </Author.Infos>
        </Author>
      </figcaption>
    </figure>
  );
};
